import { render, staticRenderFns } from "./ValidateForm.vue?vue&type=template&id=0bd2c614&scoped=true&"
import script from "./ValidateForm.vue?vue&type=script&lang=ts&"
export * from "./ValidateForm.vue?vue&type=script&lang=ts&"
import style0 from "./ValidateForm.vue?vue&type=style&index=0&id=0bd2c614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd2c614",
  null
  
)

export default component.exports